import { render, staticRenderFns } from "./area-edit.vue?vue&type=template&id=9b32a8b6&"
import script from "./area-edit.vue?vue&type=script&lang=js&"
export * from "./area-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b32a8b6')) {
      api.createRecord('9b32a8b6', component.options)
    } else {
      api.reload('9b32a8b6', component.options)
    }
    module.hot.accept("./area-edit.vue?vue&type=template&id=9b32a8b6&", function () {
      api.rerender('9b32a8b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouses/area-edit.vue"
export default component.exports